import { useQueryClient, useMutation } from 'react-query';
import { shutdownAttachments } from '../../../../shared/api/queries';
import request from '../../../../../../helpers/request';

const { shutdownAttachmentsKey } = shutdownAttachments;

const deleteAttachment = async ({ attachId }) => {
  const res = await request.delete(
    `/Alert/attachment/${attachId}`,
    {},
    'Не удалось удалить вложение',
    'Error'
  );

  return res;
};

export const useDeleteAttachment = () => {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation(deleteAttachment, {
    onSuccess: (res, { shutdownId }) => {
      if (res !== 'Error') {
        queryClient.invalidateQueries(shutdownAttachmentsKey(shutdownId));
      }
    },
  });

  return {
    deleteAttachment: deleteMutation.mutateAsync,
    loading: deleteMutation.isLoading,
  };
};
